import axios from "../axios";

const OTHER_NAME = /^(other|أخرى|غير ذلك)$/i;

const extractReasons = (payload) => {
  const data = payload?.data ?? payload;
  if (Array.isArray(data)) return data;
  if (!data || typeof data !== "object") {
    return Array.isArray(payload?.reasons) ? payload.reasons : [];
  }
  if (Array.isArray(data.reasons)) return data.reasons;
  if (Array.isArray(data.guest_reasons)) return data.guest_reasons;
  if (Array.isArray(data.report_reasons)) return data.report_reasons;
  if (Array.isArray(data.data)) return data.data;
  if (Array.isArray(payload?.reasons)) return payload.reasons;
  return [];
};

export const normalizeReason = (raw) => {
  if (raw == null) return null;
  if (typeof raw === "string" || typeof raw === "number") {
    return { id: raw, name: String(raw) };
  }
  const id = raw.id ?? raw.report_reason_id ?? raw.reason_id;
  if (id == null) return null;
  const name = String(
    raw.name || raw.title || raw.reason || raw.label || "",
  ).trim();
  return { ...raw, id, name };
};

export const isOtherReason = (reason) => {
  if (!reason) return false;
  if (
    reason.is_other ||
    reason.isOther ||
    reason.requires_details ||
    reason.requires_additional_details ||
    reason.requiresAdditionalDetails
  ) {
    return true;
  }
  const slug = String(reason.slug || reason.key || reason.code || "").toLowerCase();
  if (slug === "other") return true;
  return OTHER_NAME.test(String(reason.name || "").trim());
};

export const fetchGuestReportReasons = async (
  roomUuid,
  lang,
  { signal } = {},
) => {
  const { data } = await axios.get(`/${roomUuid}/report/get-guest-reasons`, {
    headers: { lang },
    signal,
  });

  if (data?.status === false || data?.success === false) {
    throw new Error(data?.message || "Could not load report reasons.");
  }

  return extractReasons(data).map(normalizeReason).filter(Boolean);
};

export const submitGuestDeviceReport = async ({
  roomUuid,
  sessionId,
  reasonId,
  additionalDetails,
  lang,
  signal,
}) => {
  const formData = new FormData();
  formData.append("session_id", String(sessionId));
  formData.append("report_reason_id", String(reasonId));
  if (additionalDetails) {
    formData.append("additional_details", additionalDetails);
  }

  const { data } = await axios.post(
    `/${roomUuid}/report/store`,
    formData,
    {
      headers: {
        lang,
        "Content-Type": "multipart/form-data",
      },
      signal,
    },
  );

  if (data?.status === false || data?.success === false) {
    throw new Error(data?.message || "Could not submit report. Please try again.");
  }

  return data;
};
